import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Statistics} from './statistics.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';
import {GameOverModel} from '../models/GameOverModel.js';
import {formatNumber} from '../utils/Utils.js';
import {RankManager} from './rank-manager.js';
import {Localization} from '../utils/Localization.js';
import {formatString} from '../ui/utils/utils.js';
import {Analytics, AnalyticsEvent} from '../classes/Analytics.js';
import {AudioDirector} from './audio-director.js';
import {Sounds} from '../enums/Sounds.js';
import {GameFlowController} from './game-flow-controller.js';
import {NotificationLevel} from '../enums/NotificationLevel.js';

export class TallyEndTotals extends Component {
    static TypeName = 'tally-end-totals';

    private _coinsToAdd: number;
    private _coinsPreviously: number;
    _showTally: boolean;
    _addedXp: number;
    _previousRank: number;
    _previousXp: number;

    init() {}

    start() {}

    update(dt: number) {}

    setUp(coinsAdded: number, initialRank: number, initialXp: number, newXp: number) {
        this._coinsToAdd = coinsAdded;

        const total = Statistics.instance.getTransactional(TransactionalNames.CoinCount);
        this._coinsPreviously = total - this._coinsToAdd;

        if (this._coinsToAdd > 0) {
            GameOverModel.instance.setAdForCoinsButtonVisible(true);
        }

        GameOverModel.instance.setCoins(this._coinsToAdd);
        GameOverModel.instance.setTotalCoins(this._coinsPreviously);

        this._showTally = true;

        this._addedXp = newXp;
        // Logger.Log("score controller + " + addedXp);
        this._previousRank = initialRank;
        this._previousXp = initialXp;

        //show old rank and slider values
        this._showRank(initialRank);
        GameOverModel.instance.setXpPercentage(
            newXp / RankManager.instance.getXpTarget(initialRank)
        );

        //TK: For now, call this directly
        this._addRank();
    }

    addXpReward(newXp: number) {
        this._addedXp += newXp;

        //TK: For now, call this directly
        this._addRank();
    }

    addCoinReward(newCoins: number) {
        this._coinsToAdd += newCoins;
        GameOverModel.instance.setCoins(this._coinsToAdd);
        GameOverModel.instance.setTotalCoins(this._coinsPreviously + this._coinsToAdd);
    }

    /**
     * TK: Originally this was a coroutine that triggered on onEnable. Current version
     * worls slightly different, but keeping the separate method, just in case.
     */
    private _addRank() {
        const rankManager = RankManager.instance;
        // //set slider appropriately
        // rankSlider.sliderValue = (float)previousXp / RankManager.GetInstance().GetXpTarget(previousRank);
        let rankLevel = this._previousRank;
        const format = Localization.instance.get('RankFormat');
        // rankText.text = string.Format(format, Utils.FormatNumber(rankLevel));

        // // determine new xp
        const currentRank = this._previousRank;
        const currentXp = this._previousXp;

        let {newRank, newXp} = rankManager.figureOutNewRank(
            currentRank,
            currentXp,
            this._addedXp,
            true
        );

        GameOverModel.instance.setRank(formatString(format, formatNumber(newRank)));
        GameOverModel.instance.setXpPercentage(
            newXp / RankManager.instance.getXpTarget(newRank)
        );

        // did you level up? if so, let's level you up..
        for (let x = currentRank; x < newRank; x++) {
            //Utils.SetActiveRecursively(rankUpRoot, true);
            //rankUp.text = Localization.instance.Get("RankUp");
            //TweenScale rankScale = rankUpRoot.GetComponentInChildren<TweenScale>();
            //rankScale.Play(true);
            //TweenColor rankColor = rankUpRoot.GetComponentInChildren<TweenColor>();
            //rankColor.Play(true);
            //rankScale.delay = 1.0f;
            //rankColor.delay = 1.0f;
            //scoreTextColor.Reset();
            //scoreTextColor.duration = 3.0f;
            //scoreTextColor.delay = 1.0f;
            //scoreTextColor.Play(true);
            //yield return StartCoroutine(AdjustRankSlider(1.0f));
            rankLevel++;
            // 	rankText.text = string.Format(format, Utils.FormatNumber(rankLevel));
            Analytics.LogEventWithValue(AnalyticsEvent.RankUp, 1);
            Analytics.LogEventWithValue(AnalyticsEvent.GameRank, rankLevel);

            //AudioDirector.instance.playOneShot(Sounds.rankUp, true);

            // 	//set slider to 0
            // 	yield return StartCoroutine(AdjustRankSlider(0.0f));
        }
    }

    private _showRank(rankLevel: number) {
        const format = Localization.instance.get('RankFormat');

        GameOverModel.instance.setRank(formatString(format, formatNumber(rankLevel)));
        GameOverModel.instance.setXpPercentage(
            RankManager.instance.currentRankPercentComplete
        );
    }
}
